export default __webpack_public_path__ + "static/media/gitlab.bdcff436.png";